import { render, staticRenderFns } from "./SwitchPlan.vue?vue&type=template&id=4dab5a93&scoped=true&"
import script from "./SwitchPlan.vue?vue&type=script&lang=js&"
export * from "./SwitchPlan.vue?vue&type=script&lang=js&"
import style0 from "./SwitchPlan.vue?vue&type=style&index=0&id=4dab5a93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dab5a93",
  null
  
)

export default component.exports